import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 22"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="m18.62 11.593.473-1.77c.554-2.068.832-3.101.623-3.996a3.667 3.667 0 0 0-1.065-1.843c-.67-.628-1.704-.905-3.77-1.458-2.068-.555-3.102-.832-3.996-.624a3.667 3.667 0 0 0-1.843 1.065c-.538.574-.819 1.415-1.236 2.942l-.223.83-.474 1.77c-.555 2.068-.832 3.1-.624 3.995a3.667 3.667 0 0 0 1.066 1.844c.67.628 1.704.904 3.77 1.46 1.863.498 2.887.772 3.726.668.092-.01.181-.027.27-.047a3.668 3.668 0 0 0 1.843-1.064c.628-.67.905-1.705 1.46-3.772Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M15.047 16.476a3.668 3.668 0 0 1-.979 1.538c-.67.628-1.704.905-3.771 1.459-2.067.553-3.101.831-3.995.622a3.667 3.667 0 0 1-1.843-1.064c-.628-.67-.906-1.704-1.46-3.771l-.474-1.771c-.554-2.067-.831-3.101-.623-3.995a3.667 3.667 0 0 1 1.065-1.843c.67-.628 1.704-.905 3.771-1.46.39-.104.746-.2 1.068-.283"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="m10.796 9.167 4.427 1.186m-5.14 1.47 2.657.712"
    />
  </svg>
)
export default SvgComponent
